module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.first) ? _c('hr') : _vm._e(), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.section.heading) ? _c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.section.heading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.section.image.url) ? _c('div', {
    staticClass: "article__feature embed-responsive embed-responsive-16by9",
    staticStyle: {
      "height": "auto",
      "padding-bottom": "0"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.section.image.url
    }
  })]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.section.body)
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6448a6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/image_full_width/image_full_width.vue
// module id = 675
// module chunks = 0